import React from 'react'
import { i18n } from 'LibNeo/utils/intl'
import { ORIENTATION, SPACE_SYMBOL } from 'Src/constants/Global'
import { XOR } from 'Helpers'
import { IconComponent, UISizes, UITypes, Text, TextType } from 'LibNeo'
import { Space, TextRow, Title, Value } from './styled'

type ComponentProps = XOR<
	{
		space: boolean
	},
	{
		title: string
		orientation?: ORIENTATION
		info?: string
		children?: React.ReactNode
	}
>

export const TextRowComponent: React.FC<ComponentProps> = ({
	title,
	info,
	children,
	space,
	orientation = ORIENTATION.HORIZONTAL,
}) => {
	return (
		<>
			{title && (
				<TextRow orientation={orientation}>
					<Title orientation={orientation}>
						<Text type={TextType.CAPTION}>{i18n(title)}</Text>
						{info && (
							<IconComponent
								name="alert-circle"
								type={UITypes.GREY_LIGHT}
								size={UISizes.SMALL}
								tooltip={info}
							/>
						)}
					</Title>
					<Value type={TextType.BODY2}>{children || SPACE_SYMBOL}</Value>
				</TextRow>
			)}
			{space && <Space />}
		</>
	)
}
